import React, { useState } from "react";
import { useNavigate } from 'react-router-dom';
import { ChevronDown } from "lucide-react";
import '../LandingPage.css';

/**
 * Shared sidebar component that appears on all pages
 */
export default function AppSidebar() {
  const navigate = useNavigate();
  const [buyWriteExpanded, setBuyWriteExpanded] = useState(false);
  const [ironCondorExpanded, setIronCondorExpanded] = useState(false);
  const [butterflyExpanded, setButterflyExpanded] = useState(false);

  return (
    <aside className="landing-sidebar">
      {/* Logo - First Item */}
      <div
        onClick={() => navigate('/')}
        style={{
          marginBottom: '24px',
          padding: '12px',
          cursor: 'pointer',
          borderRadius: '8px',
          transition: 'background 0.2s',
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          gap: '8px'
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = 'rgba(59, 130, 246, 0.1)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = 'transparent';
        }}
      >
        <img
          src="/favicon.png"
          alt="Market Intelligence Logo"
          style={{
            width: '80px',
            height: '80px',
            objectFit: 'contain'
          }}
        />
      </div>

      <div style={{ marginBottom: '16px', fontSize: '14px', fontWeight: '600' }}>
        Trading Analysis
      </div>

      <nav>
        {/* Buy Write with submenu */}
        <div>
          <button
            className="landing-sidebar-item"
            onClick={() => setBuyWriteExpanded(!buyWriteExpanded)}
          >
            <span>✍️ Buy Write</span>
            <ChevronDown
              size={14}
              style={{
                transition: 'transform 0.2s',
                transform: buyWriteExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
              }}
            />
          </button>
          {buyWriteExpanded && (
            <div style={{ marginLeft: '24px', marginTop: '4px' }}>
              <button
                className="landing-sidebar-submenu-item"
                onClick={() => navigate('/mainMenuBuyWrite')}
              >
                Analysis
              </button>
              <button
                className="landing-sidebar-submenu-item"
                onClick={() => navigate('/myPortfolio')}
              >
                Portfolio
              </button>
              <button
                className="landing-sidebar-submenu-item"
                onClick={() => navigate('/settings')}
              >
                Settings
              </button>
            </div>
          )}
        </div>

        {/* Iron Condor with submenu */}
        <div>
          <button
            className="landing-sidebar-item"
            onClick={() => setIronCondorExpanded(!ironCondorExpanded)}
          >
            <span>🦅 Iron Condor</span>
            <ChevronDown
              size={14}
              style={{
                transition: 'transform 0.2s',
                transform: ironCondorExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
              }}
            />
          </button>
          {ironCondorExpanded && (
            <div style={{ marginLeft: '24px', marginTop: '4px' }}>
              <button
                className="landing-sidebar-submenu-item"
                onClick={() => navigate('/ironCondorMenu')}
              >
                Reverse
              </button>
              <button
                className="landing-sidebar-submenu-item"
                onClick={() => navigate('/ironCondorTraditionalMenu')}
              >
                Traditional
              </button>
              <button
                className="landing-sidebar-submenu-item"
                onClick={() => navigate('/myPortfolioIronCondor', { state: { icType: "LONG" } })}
              >
                Reverse Portfolio
              </button>
              <button
                className="landing-sidebar-submenu-item"
                onClick={() => navigate('/myPortfolioIronCondor', { state: { icType: "SHORT" } })}
              >
                Traditional Portfolio
              </button>
            </div>
          )}
        </div>

        {/* Butterfly with submenu */}
        <div>
          <button
            className="landing-sidebar-item"
            onClick={() => setButterflyExpanded(!butterflyExpanded)}
          >
            <span>🦋 Butterfly</span>
            <ChevronDown
              size={14}
              style={{
                transition: 'transform 0.2s',
                transform: butterflyExpanded ? 'rotate(180deg)' : 'rotate(0deg)'
              }}
            />
          </button>
          {butterflyExpanded && (
            <div style={{ marginLeft: '24px', marginTop: '4px' }}>
              <button
                className="landing-sidebar-submenu-item"
                onClick={() => navigate('/butterflyMenu')}
              >
                Long
              </button>
              <button
                className="landing-sidebar-submenu-item"
                style={{
                  opacity: 0.5,
                  cursor: 'not-allowed',
                  pointerEvents: 'none'
                }}
              >
                Short
              </button>
              <button
                className="landing-sidebar-submenu-item"
                style={{
                  opacity: 0.5,
                  cursor: 'not-allowed',
                  pointerEvents: 'none'
                }}
              >
                Iron
              </button>
              <button
                className="landing-sidebar-submenu-item"
                onClick={() => navigate('/myPortfolioButterfly')}
              >
                Portfolio
              </button>
              <button
                className="landing-sidebar-submenu-item"
                onClick={() => navigate('/butterflySettings')}
              >
                Settings
              </button>
            </div>
          )}
        </div>

        <button className="landing-sidebar-item" onClick={() => navigate('/mainMenuLongTerm')}>
          <span>📈 Long Term</span>
        </button>
      </nav>
    </aside>
  );
}
